// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__1LzJk","file":"styles_file__2mh7s"};